import { Component, OnInit } from '@angular/core';
import { ExamService } from 'src/app/services/Exam/exam.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { GlobalHelper } from 'src/app/services/Common/global.service';

@Component({
    selector: 'app-student-report-card',
    templateUrl: './student-report-card.component.html',
    styleUrls: ['./student-report-card.component.css']
})
export class StudentReportCardComponent implements OnInit {

    constructor(private examService: ExamService, private lookupService: LookupService, private globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }



    StudentScoreCardModel = {
        StudentID: 0,
        ClassID: 0,
        ClassSectionID: "",
        SectionID: 0,
        Class: "",
        ReportType: 'ANNUAL',
        TermID: 0,
        ExamMapID: 0,
    }



    ExamScoreCardTypeList: any;;
    StudentList = [];
    AllPrint(PrintType) {
        if (this.StudentScoreCardModel.ReportType == 'ANNUAL') {
            this.StudentScoreCardModel.TermID = 0;
        }
        var ScoreCardTypeID = this.ExamScoreCardTypeList.ItemId;
        var ExamMapID = 0;
        var objStudent = '';
        var objClassID = '';
        var objSectionID = '';
        var ClassName = '';
        var Sections = '';
        var StudentName = "";

        for (var i = 0; i < this.StudentList.length; i++) {
            if (this.StudentList[i].IsActive) {
                objStudent = objStudent == '' ? this.StudentList[i].StudentID : objStudent + ',' + this.StudentList[i].StudentID;
                objClassID = this.StudentList[i].ClassID;
                objSectionID = this.StudentList[i].SectionID;

            }
        }

        var template = this.ExamScoreCardTypeList.ItemName;
        var url = template + "?StudentID=" + objStudent + "&ClassID=" + objClassID + "&SectionID=" + objSectionID + '&ScoreCardTypeID=' + ScoreCardTypeID + '&TermID=' + this.StudentScoreCardModel.TermID + "&PrintType=" + PrintType;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");


    }


    PrintScoreCard(item, PrintType) {
        if (this.StudentScoreCardModel.ReportType == 'ANNUAL') {
            this.StudentScoreCardModel.TermID = 0;
        }
        var ExamMapID = this.StudentScoreCardModel.ExamMapID;
        var ScoreCardTypeID = this.ExamScoreCardTypeList.ItemId;
        var objStudent = item.StudentID;
        var objClassID = item.ClassID;
        var objSectionID = item.SectionID;
        var template = this.ExamScoreCardTypeList.ItemName;
        var url = template + "?StudentID=" + objStudent + "&ClassID=" + objClassID + "&SectionID=" + objSectionID + '&ScoreCardTypeID=' + ScoreCardTypeID + '&TermID=' + this.StudentScoreCardModel.TermID + "&ExamMapID=" + ExamMapID+"&PrintType="+PrintType;
        this.globalHelper.OpenPopUpWindow(url, "yes", "950", "1000");

    }
    ValidateDropdown() {
        return this.StudentScoreCardModel.ClassID == 0 || (this.StudentScoreCardModel.ReportType == 'TERMWISE' && this.StudentScoreCardModel.TermID == 0);
    };
    Submitted = false;
    GetStudentScoreCard() {
        this.Submitted = true;
        if (!this.ValidateDropdown()) {
            this.spinnerService.show();
            this.examService.GetStudentScoreCard(this.StudentScoreCardModel.ClassID, this.StudentScoreCardModel.SectionID, this.StudentScoreCardModel.ReportType, this.StudentScoreCardModel.TermID).subscribe((data) => {
                this.StudentList = data.StudentList;
                this.Submitted = false;
                this.GetExamScoreCardType();
                this.spinnerService.hide();
            });
        }
    }

    PrintButton = true;
    IsSelect = false
    SelectAll() {
        if (this.IsSelect) {
            for (var i = 0; i < this.StudentList.length; i++) {
                this.StudentList[i].IsActive = true;
                this.PrintButton = false;
            }
        }
        if (this.IsSelect == false) {
            for (var i = 0; i < this.StudentList.length; i++) {
                this.StudentList[i].IsActive = false;
                this.PrintButton = true;
            }
        }
    }
    Count1 = 0;
    ChangeSelect(item) {
        this.Count1 = 0;
        for (var i = 0; i < this.StudentList.length; i++) {
            if (this.StudentList[i].IsActive) {
                this.Count1 = this.Count1 + 1
                this.PrintButton = false;
            }
        }
        if (this.Count1 == this.StudentList.length) {
            this.IsSelect = true;
            this.PrintButton = false;
        }
        else {
            this.IsSelect = false;
        }

    }


    ClassSectionList: any;
    GetClassSection() {
        this.lookupService.GetLookupsList('CTClassSection', '').subscribe((data) => {
            this.ClassSectionList = data.LookupItems;

        });
    };

    SetID() {

        this.StudentScoreCardModel.ClassID = 0;
        this.StudentScoreCardModel.SectionID = 0;
        this.StudentScoreCardModel.TermID = 0;
        this.StudentList = [];
        if (this.StudentScoreCardModel.ClassSectionID != "") {
            var strClassSectionID = this.StudentScoreCardModel.ClassSectionID.split('-');
            this.StudentScoreCardModel.ClassID = parseInt(strClassSectionID[0]);
            this.StudentScoreCardModel.SectionID = parseInt(strClassSectionID[1]);
            this.GetTerm();

        }
    }

    ExamMasterList = [];
    GetExamMaster() {
        this.spinnerService.show();
        this.ExamMasterList = [];
        this.StudentScoreCardModel.ExamMapID = 0;
        this.StudentScoreCardModel.TermID = this.StudentScoreCardModel.TermID == null ? 0 : this.StudentScoreCardModel.TermID;
        var item = {
            ItemId: this.StudentScoreCardModel.ClassID,
            ItemId2: this.StudentScoreCardModel.TermID,
        }
        this.lookupService.GetLookupsList('ExamEntry', JSON.stringify(item)).subscribe((data) => {
            this.ExamMasterList = data.LookupItems;
            this.spinnerService.hide();

        });
    };
    Clear() {
        this.StudentScoreCardModel.ClassSectionID = "";
        this.StudentScoreCardModel.ClassID = 0;
        this.StudentScoreCardModel.SectionID = 0;
        this.StudentScoreCardModel.TermID = 0;
        this.StudentScoreCardModel.ExamMapID = 0;
        this.StudentScoreCardModel.ReportType = 'ANNUAL';
        this.StudentList = [];
        this.Submitted = false;
    }
    ClearList() {
        this.StudentList = [];
        // this.ExamScoreCardTypeList.ItemId = 0;
    }
    GetExamScoreCardType() {

        var itembo = {
            'ItemId': this.StudentScoreCardModel.ClassID,
            'ItemCode1': this.StudentScoreCardModel.ReportType,
            'ItemId1': this.StudentScoreCardModel.TermID,
        }

        this.lookupService.GetLookupsList('ExamScoreCardType', JSON.stringify(itembo)).subscribe((data) => {
            this.ExamScoreCardTypeList = data.LookupItems[1];

        });
    }
    ngOnInit() {
        this.GetClassSection();
    }

    TermList = [];
    GetTerm() {
        this.StudentScoreCardModel.TermID = 0;
        this.spinnerService.show();
        this.TermList = [];

        var ItemBo = {
            ItemId: this.StudentScoreCardModel.ClassID
        }
        this.lookupService.GetLookupsList('ExamTerm', JSON.stringify(ItemBo)).subscribe((data) => {
            this.TermList = data.LookupItems;
            this.spinnerService.hide();
        });
    };

}
